import { render, staticRenderFns } from "./CollectionPageStructuredData.vue?vue&type=template&id=84cfcece"
import script from "./CollectionPageStructuredData.vue?vue&type=script&lang=js"
export * from "./CollectionPageStructuredData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports